import { styled } from "@mui/material";

export const FooterLogo = styled("a")(({ theme }) => ({
  padding: "1rem",
  width: "10rem",
  background: theme.palette.color.main.primary,
  borderRadius: "3rem",
  textAlign: "center",
  marginLeft: "-1rem",

  "& img": {
    opacity: 0.85,
    width: "4.5rem",
    margin: "0 auto",
    verticalAlign: "middle",
    borderStyle: "none",
  },

  "& img:hover": {
    opacity: 1,
  },
}));

export const FooterContainerWrapper = styled("div")({
  margin: 0,
});

export const FooterContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
});

export const FooterContent = styled("div")(({ theme }) => ({
  padding: "2.5rem 1rem 8rem 1rem",
  width: "100%",

  "& .FooterColumn": {
    paddingLeft: "1rem",

    "& .FooterColumnContainer": {
      "& p": {
        margin: 0,
        lineHeight: "2rem",

        "& a": {
          color: theme.palette.color.content.textDark || "#4f5464", // rgb(var(--color-text))
          textDecoration: "underline",

          "&:hover": {
            color: theme.palette.color.content.hover || "#000BFF", // rgb(var(--color-hover))
          },
        },
      },
    },

    "&.First": {
      "& div": {
        margin: "0.5rem 0",
      },

      "& p": {
        fontSize: "0.65rem",
        opacity: 0.5,
        marginTop: "1rem",
      },
    },

    "&:not(.First)": {
      borderLeft: `1px solid ${theme.palette.color.content.border}`, // rgb(var(--color-border))

      "& strong": {
        display: "inline-block",
        color: theme.palette.color.content.textDark || "#4f5464", // rgb(var(--color-text))
        marginBottom: "1rem",
      },
    },
  },

  "@media (max-width: 980px)": {
    "& #FooterBlocks": {
      display: "flex",
      flexDirection: "column",

      "& .FooterColumn": {
        borderLeft: "none",
        flexBasis: "100%",
        maxWidth: "100%",
      },
    },
  },
}));

export const FooterMain = styled("div")(({ theme }) => ({
  marginTop: "3.25rem",
  paddingTop: "0.5rem",
  color: theme.palette.color.content.textDark || "#4f5464", // rgb(var(--color-text))
  background: theme.palette.color.content.background || "#EFF6F9", // rgb(var(--color-bg-content))

  "& a": {
    color: theme.palette.color.content.textDark || "#939EB8", // rgb(var(--color-gray))
  },
  "& a:hover": {
    color: "white",
  },

  "& h3": {
    color: theme.palette.color.main.secondary || "#243050", // rgb(var(--color-secondary))
    fontSize: "1.25rem",
    margin: "0 0 0.95rem -0.2rem",
    padding: 0,
  },
}));

export const FooterClientLogosWrapper = styled("div")(({ theme }) => ({
  background: theme.palette.color.content.background || "#F9FCFE", // rgb(var(--color-bg))
  padding: "0.5rem 2.5rem 1rem 2.5rem",
  borderRadius: "0.5rem", // var(--radius-md)
  maxWidth: "1200px",
  margin: "0.5rem auto",

  "& h2": {
    textAlign: "center",
  },

  "@media (max-width: 720px)": {
    margin: "0 1rem",
    "& h2": {
      fontSize: "1.25rem",
      lineHeight: "1.5rem",
    },
  },
}));

export const ClientLogos = styled("div")({
  "& img": {
    width: "100%",
    padding: "1rem 2rem",
  },

  "@media (max-width: 720px)": {
    "& img": {
      padding: 0,
      margin: "0 -7.5vw",
      width: "85vw",
    },
  },
});
